import { ListItem, ListItemButton, ListItemText, Skeleton, useTheme } from '@mui/material';
import { VideosSkeleton } from './VideosSkeleton.tsx';

export const VideoGroupSkeleton = () => {
  const theme = useTheme();

  return (
    <ListItem disablePadding sx={{ flexDirection: 'column' }}>
      <ListItemButton
        sx={{
          backgroundColor: theme.palette.grey[900],
          borderBottom: '1px solid',
          borderBottomColor: theme.supportingTextSecondary,
          boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
          color: theme.supportingTextSecondary,
          flexGrow: 0,
          maxHeight: '49px',
          paddingTop: theme.spacing(2),
          position: 'sticky',
          top: '56px',
          width: '100%',
          zIndex: 1,
        }}
      >
        <ListItemText
          primary={
            <Skeleton
              sx={{
                borderRadius: theme.spacing(1),
                height: '24px',
                marginBottom: theme.spacing(1),
                width: '250px',
              }}
              variant="rectangular"
            />
          }
        />
      </ListItemButton>
      <VideosSkeleton />
    </ListItem>
  );
};
